import contentControls from "./contentControlsService"
import { SECTION } from "@/constants/contentControlTypes";
import { SECTION as SECTION_COLOR } from "@/constants/contentControlColors";
import { tryLoadProperties } from "@/util/wordUtil";

const add = (name, hideBoundingBox = false) => new Promise(resolve => {
    const title = `Sharedo ${SECTION}: ${name}`;
    const options = {
        placeholderText: title,
        color: SECTION_COLOR,
        tag: name,
        hideBoundingBox
    };

    contentControls.insert(title, options, ({ contentControl, parentContentControl, context }) => {
        tryLoadProperties(context, contentControl, "id").then(() => {
            const retVal = { id: contentControl.id };

            if (parentContentControl) {
                retVal.parentId = parentContentControl.id;
            }

            resolve(retVal);
        });
    });
});

export default {
    add
}